export enum DeviceOS {
  Android = "Android",
  iOS = "iOS",
  Windows = "Windows",
  MacOS = "Mac OS",
  Linux = "Linux",
  Unix = "Unix",
  Unknown = "Unknown",
}
